import { render, staticRenderFns } from "./CartProducts.vue?vue&type=template&id=33cdc4e8&scoped=true&"
import script from "./CartProducts.vue?vue&type=script&lang=js&"
export * from "./CartProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cdc4e8",
  null
  
)

export default component.exports